export default __webpack_public_path__ + "static/media/Snd_C7.86dd35fe.mp3";